import type { ReactNode } from "react";
import { Badge } from "@generalapplications/ui";

export type TagProps = {
  children: ReactNode;
};

/** This site's tag and eyebrow: the library's soft badge in the brand colour, as PlantHarvester draws its tags. */
export function Tag({ children }: TagProps) {
  return (
    <Badge tone="primary" size="sm">
      {children}
    </Badge>
  );
}
